/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { FeatureFlagsDto } from './feature-flags-dto';
// May contain unused imports in some cases
// @ts-ignore
import { PointsExpiryDto } from './points-expiry-dto';
// May contain unused imports in some cases
// @ts-ignore
import { ScreenShotsDto } from './screen-shots-dto';

/**
 * 
 * @export
 * @interface AppDto
 */
export interface AppDto {
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'industry': string | null;
    /**
     * 
     * @type {number}
     * @memberof AppDto
     */
    'aov': number | null;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'logo': string | null;
    /**
     * 
     * @type {ScreenShotsDto}
     * @memberof AppDto
     */
    'screenshots': ScreenShotsDto;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'agent': AppDtoAgentEnum;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'language': AppDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'currency': AppDtoCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'country': AppDtoCountryEnum;
    /**
     * 
     * @type {number}
     * @memberof AppDto
     */
    'timezone': number;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'timezoneIana'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'domain': string;
    /**
     * 
     * @type {PointsExpiryDto}
     * @memberof AppDto
     */
    'pointsExpiry': PointsExpiryDto;
    /**
     * 
     * @type {boolean}
     * @memberof AppDto
     */
    'emails': boolean;
    /**
     *
     * @type {boolean}
     * @memberof AppDto
     */
    'enabled': boolean;
    /**
     *
     * @type {boolean}
     * @memberof AppDto
     */
    'active': boolean;
    /**
     *
     * @type {object}
     * @memberof AppDto
     */
    'metadata'?: object;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppDto
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'identifier': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppDto
     */
    'types': Array<AppDtoTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'program'?: AppDtoProgramEnum;
    /**
     * 
     * @type {string}
     * @memberof AppDto
     */
    'paymentGateway': AppDtoPaymentGatewayEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppDto
     */
    'collectUserInfo': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppDto
     */
    'retailers'?: Array<string>;
    /**
     * 
     * @type {FeatureFlagsDto}
     * @memberof AppDto
     */
    'featureFlags': FeatureFlagsDto;
}

export const AppDtoAgentEnum = {
    Vtex: 'vtex',
    Shopify: 'shopify',
    Prestashop: 'prestashop',
    Nuvemshop: 'nuvemshop',
    Magento: 'magento',
    Tray: 'tray',
    Wake: 'wake',
    Custom: 'custom',
    WooCommerce: 'wooCommerce',
    Loja: 'loja'
} as const;

export type AppDtoAgentEnum = typeof AppDtoAgentEnum[keyof typeof AppDtoAgentEnum];
export const AppDtoLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type AppDtoLanguageEnum = typeof AppDtoLanguageEnum[keyof typeof AppDtoLanguageEnum];
export const AppDtoCurrencyEnum = {
    Aed: 'aed',
    Afn: 'afn',
    All: 'all',
    Amd: 'amd',
    Ang: 'ang',
    Aoa: 'aoa',
    Ars: 'ars',
    Aud: 'aud',
    Awg: 'awg',
    Azn: 'azn',
    Bam: 'bam',
    Bbd: 'bbd',
    Bdt: 'bdt',
    Bgn: 'bgn',
    Bhd: 'bhd',
    Bif: 'bif',
    Bmd: 'bmd',
    Bnd: 'bnd',
    Bob: 'bob',
    Brl: 'brl',
    Bsd: 'bsd',
    Btn: 'btn',
    Bwp: 'bwp',
    Byn: 'byn',
    Bzd: 'bzd',
    Cad: 'cad',
    Cdf: 'cdf',
    Chf: 'chf',
    Clp: 'clp',
    Cny: 'cny',
    Cop: 'cop',
    Crc: 'crc',
    Cuc: 'cuc',
    Cup: 'cup',
    Cve: 'cve',
    Czk: 'czk',
    Djf: 'djf',
    Dkk: 'dkk',
    Dop: 'dop',
    Dzd: 'dzd',
    Egp: 'egp',
    Ern: 'ern',
    Etb: 'etb',
    Eur: 'eur',
    Fjd: 'fjd',
    Fkp: 'fkp',
    Gbp: 'gbp',
    Gel: 'gel',
    Ghs: 'ghs',
    Gip: 'gip',
    Gmd: 'gmd',
    Gnf: 'gnf',
    Gtq: 'gtq',
    Gyd: 'gyd',
    Hkd: 'hkd',
    Hnl: 'hnl',
    Hrk: 'hrk',
    Htg: 'htg',
    Huf: 'huf',
    Idr: 'idr',
    Ils: 'ils',
    Inr: 'inr',
    Iqd: 'iqd',
    Irr: 'irr',
    Isk: 'isk',
    Jmd: 'jmd',
    Jod: 'jod',
    Jpy: 'jpy',
    Kes: 'kes',
    Kgs: 'kgs',
    Khr: 'khr',
    Kmf: 'kmf',
    Kpw: 'kpw',
    Krw: 'krw',
    Kwd: 'kwd',
    Kyd: 'kyd',
    Kzt: 'kzt',
    Lak: 'lak',
    Lbp: 'lbp',
    Lkr: 'lkr',
    Lrd: 'lrd',
    Lsl: 'lsl',
    Lyd: 'lyd',
    Mad: 'mad',
    Mdl: 'mdl',
    Mga: 'mga',
    Mkd: 'mkd',
    Mmk: 'mmk',
    Mnt: 'mnt',
    Mop: 'mop',
    Mru: 'mru',
    Mur: 'mur',
    Mvr: 'mvr',
    Mwk: 'mwk',
    Mxn: 'mxn',
    Myr: 'myr',
    Mzn: 'mzn',
    Nad: 'nad',
    Ngn: 'ngn',
    Nio: 'nio',
    Nok: 'nok',
    Npr: 'npr',
    Nzd: 'nzd',
    Omr: 'omr',
    Pab: 'pab',
    Pen: 'pen',
    Pgk: 'pgk',
    Php: 'php',
    Pkr: 'pkr',
    Pln: 'pln',
    Pyg: 'pyg',
    Qar: 'qar',
    Ron: 'ron',
    Rsd: 'rsd',
    Rub: 'rub',
    Rwf: 'rwf',
    Sar: 'sar',
    Sbd: 'sbd',
    Scr: 'scr',
    Sdg: 'sdg',
    Sek: 'sek',
    Sgd: 'sgd',
    Shp: 'shp',
    Sll: 'sll',
    Sos: 'sos',
    Srd: 'srd',
    Ssp: 'ssp',
    Stn: 'stn',
    Svc: 'svc',
    Syp: 'syp',
    Szl: 'szl',
    Thb: 'thb',
    Tjs: 'tjs',
    Tmt: 'tmt',
    Tnd: 'tnd',
    Top: 'top',
    Try: 'try',
    Ttd: 'ttd',
    Twd: 'twd',
    Tzs: 'tzs',
    Uah: 'uah',
    Ugx: 'ugx',
    Usd: 'usd',
    Uyu: 'uyu',
    Uzs: 'uzs',
    Ves: 'ves',
    Vnd: 'vnd',
    Vuv: 'vuv',
    Wst: 'wst',
    Xaf: 'xaf',
    Xcd: 'xcd',
    Xof: 'xof',
    Xpf: 'xpf',
    Yer: 'yer',
    Zar: 'zar',
    Zmw: 'zmw',
    Zwl: 'zwl'
} as const;

export type AppDtoCurrencyEnum = typeof AppDtoCurrencyEnum[keyof typeof AppDtoCurrencyEnum];
export const AppDtoCountryEnum = {
    Us: 'us',
    Af: 'af',
    Ax: 'ax',
    Al: 'al',
    Dz: 'dz',
    As: 'as',
    Ad: 'ad',
    Ao: 'ao',
    Ai: 'ai',
    Aq: 'aq',
    Ag: 'ag',
    Ar: 'ar',
    Am: 'am',
    Aw: 'aw',
    Au: 'au',
    At: 'at',
    Az: 'az',
    Bs: 'bs',
    Bh: 'bh',
    Bd: 'bd',
    Bb: 'bb',
    By: 'by',
    Be: 'be',
    Bz: 'bz',
    Bj: 'bj',
    Bm: 'bm',
    Bt: 'bt',
    Bo: 'bo',
    Bq: 'bq',
    Ba: 'ba',
    Bw: 'bw',
    Bv: 'bv',
    Br: 'br',
    Io: 'io',
    Bn: 'bn',
    Bg: 'bg',
    Bf: 'bf',
    Bi: 'bi',
    Kh: 'kh',
    Cm: 'cm',
    Ca: 'ca',
    Cv: 'cv',
    Ky: 'ky',
    Cf: 'cf',
    Td: 'td',
    Cl: 'cl',
    Cn: 'cn',
    Cx: 'cx',
    Cc: 'cc',
    Co: 'co',
    Km: 'km',
    Cg: 'cg',
    Cd: 'cd',
    Ck: 'ck',
    Cr: 'cr',
    Ci: 'ci',
    Hr: 'hr',
    Cu: 'cu',
    Cw: 'cw',
    Cy: 'cy',
    Cz: 'cz',
    Dk: 'dk',
    Dj: 'dj',
    Dm: 'dm',
    Do: 'do',
    Ec: 'ec',
    Eg: 'eg',
    Sv: 'sv',
    Gq: 'gq',
    Er: 'er',
    Ee: 'ee',
    Et: 'et',
    Fk: 'fk',
    Fo: 'fo',
    Fj: 'fj',
    Fi: 'fi',
    Fr: 'fr',
    Gf: 'gf',
    Pf: 'pf',
    Tf: 'tf',
    Ga: 'ga',
    Gm: 'gm',
    Ge: 'ge',
    De: 'de',
    Gh: 'gh',
    Gi: 'gi',
    Gr: 'gr',
    Gl: 'gl',
    Gd: 'gd',
    Gp: 'gp',
    Gu: 'gu',
    Gt: 'gt',
    Gg: 'gg',
    Gn: 'gn',
    Gw: 'gw',
    Gy: 'gy',
    Ht: 'ht',
    Hm: 'hm',
    Va: 'va',
    Hn: 'hn',
    Hk: 'hk',
    Hu: 'hu',
    Is: 'is',
    In: 'in',
    Id: 'id',
    Ir: 'ir',
    Iq: 'iq',
    Ie: 'ie',
    Im: 'im',
    Il: 'il',
    It: 'it',
    Jm: 'jm',
    Jp: 'jp',
    Je: 'je',
    Jo: 'jo',
    Kz: 'kz',
    Ke: 'ke',
    Ki: 'ki',
    Kr: 'kr',
    Kp: 'kp',
    Kw: 'kw',
    Kg: 'kg',
    La: 'la',
    Lv: 'lv',
    Lb: 'lb',
    Ls: 'ls',
    Lr: 'lr',
    Ly: 'ly',
    Li: 'li',
    Lt: 'lt',
    Lu: 'lu',
    Mo: 'mo',
    Mk: 'mk',
    Mg: 'mg',
    Mw: 'mw',
    My: 'my',
    Mv: 'mv',
    Ml: 'ml',
    Mt: 'mt',
    Mh: 'mh',
    Mq: 'mq',
    Mr: 'mr',
    Mu: 'mu',
    Yt: 'yt',
    Mx: 'mx',
    Fm: 'fm',
    Md: 'md',
    Mc: 'mc',
    Mn: 'mn',
    Me: 'me',
    Ms: 'ms',
    Ma: 'ma',
    Mz: 'mz',
    Mm: 'mm',
    Na: 'na',
    Nr: 'nr',
    Np: 'np',
    Nl: 'nl',
    Nc: 'nc',
    Nz: 'nz',
    Ni: 'ni',
    Ne: 'ne',
    Ng: 'ng',
    Nu: 'nu',
    Nf: 'nf',
    Mp: 'mp',
    No: 'no',
    Om: 'om',
    Pk: 'pk',
    Pw: 'pw',
    Ps: 'ps',
    Pa: 'pa',
    Pg: 'pg',
    Py: 'py',
    Pe: 'pe',
    Ph: 'ph',
    Pn: 'pn',
    Pl: 'pl',
    Pt: 'pt',
    Pr: 'pr',
    Qa: 'qa',
    Re: 're',
    Ro: 'ro',
    Ru: 'ru',
    Rw: 'rw',
    Bl: 'bl',
    Sh: 'sh',
    Kn: 'kn',
    Lc: 'lc',
    Mf: 'mf',
    Pm: 'pm',
    Vc: 'vc',
    Ws: 'ws',
    Sm: 'sm',
    St: 'st',
    Sa: 'sa',
    Sn: 'sn',
    Rs: 'rs',
    Sc: 'sc',
    Sl: 'sl',
    Sg: 'sg',
    Sx: 'sx',
    Sk: 'sk',
    Si: 'si',
    Sb: 'sb',
    So: 'so',
    Za: 'za',
    Gs: 'gs',
    Ss: 'ss',
    Es: 'es',
    Lk: 'lk',
    Sd: 'sd',
    Sr: 'sr',
    Sj: 'sj',
    Sz: 'sz',
    Se: 'se',
    Ch: 'ch',
    Sy: 'sy',
    Tw: 'tw',
    Tj: 'tj',
    Tz: 'tz',
    Th: 'th',
    Tl: 'tl',
    Tg: 'tg',
    Tk: 'tk',
    To: 'to',
    Tt: 'tt',
    Tn: 'tn',
    Tr: 'tr',
    Tm: 'tm',
    Tc: 'tc',
    Tv: 'tv',
    Ug: 'ug',
    Ua: 'ua',
    Ae: 'ae',
    Gb: 'gb',
    Um: 'um',
    Uy: 'uy',
    Uz: 'uz',
    Vu: 'vu',
    Ve: 've',
    Vn: 'vn',
    Vg: 'vg',
    Vi: 'vi',
    Wf: 'wf',
    Eh: 'eh',
    Ye: 'ye',
    Zm: 'zm',
    Zw: 'zw'
} as const;

export type AppDtoCountryEnum = typeof AppDtoCountryEnum[keyof typeof AppDtoCountryEnum];
export const AppDtoTypesEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    CorePilot: 'corePilot',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AppDtoTypesEnum = typeof AppDtoTypesEnum[keyof typeof AppDtoTypesEnum];
export const AppDtoProgramEnum = {
    Points: 'points',
    Cashback: 'cashback'
} as const;

export type AppDtoProgramEnum = typeof AppDtoProgramEnum[keyof typeof AppDtoProgramEnum];
export const AppDtoPaymentGatewayEnum = {
    StripeUs: 'stripeUS',
    StripeBr: 'stripeBR',
    Shopify: 'shopify'
} as const;

export type AppDtoPaymentGatewayEnum = typeof AppDtoPaymentGatewayEnum[keyof typeof AppDtoPaymentGatewayEnum];


